import { PDFDocument } from "pdf-lib";

export const fetchFileBytes = async (url: string): Promise<ArrayBuffer> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch file (${response.status})`);
  }
  return response.arrayBuffer();
};

/**
 * Merges several PDF documents into a single PDF by appending each source
 * document's pages one after another, preserving their original dimensions.
 */
export const mergeLabelsIntoPdf = async (pdfBuffers: ArrayBuffer[]): Promise<Uint8Array> => {
  const mergedPdf = await PDFDocument.create();

  for (const buffer of pdfBuffers) {
    const source = await PDFDocument.load(buffer);
    const pages = await mergedPdf.copyPages(source, source.getPageIndices());
    pages.forEach((page) => mergedPdf.addPage(page));
  }

  return mergedPdf.save();
};
